/**
 * * 扩展配置项，标签放置在正负值方向的位置上
 *
 * @example
 * ```javascript
 * {
 *   type: 'bar',
 *   label: {
 *     dvPosition: 'valueDirection'
 *   }
 * }
 * ```
 */
import { type EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import { type BarSeriesOption } from 'echarts';
import { util } from 'echarts/core';
import { overrideIfUndefined } from '../../../util/data';

function parseBarLabelDvPosition(seriesOption: BarSeriesOption[]) {
  seriesOption.forEach(option => {
    if (
      // @ts-ignore
      option?.label?.dvPosition !== 'valueDirection' ||
      typeof option?.label?.position !== 'undefined'
    ) {
      return;
    }

    // ! 这里只处理了 data 放在 series 的情况，不处理 dataset 的情况
    if (typeof option.data === 'undefined') {
      // eslint-disable-next-line no-param-reassign
      option.data = [];
    }

    // eslint-disable-next-line no-param-reassign
    option.data = option.data.map(item => {
      if (util.isString(item) || (!util.isObject(item) && !util.isArray(item))) {
        // eslint-disable-next-line no-param-reassign
        item = {
          value: item
        };
      }

      // @ts-ignore
      if (typeof item.label === 'undefined') {
        // @ts-ignore
        // eslint-disable-next-line no-param-reassign
        item.label = {};
      }

      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      item.label.position = overrideIfUndefined(
        // @ts-ignore
        item.label.position as string,
        // @ts-ignore
        Number(item.value) >= 0 ? 'top' : 'bottom'
      );

      /** UI规范要求label到柱子的间距是4px */
      item.label.offset = overrideIfUndefined(item.label.offset, [
        0,
        Number(item.value) >= 0 ? 2 : 0
      ]);

      return item;
    });

    //
  });

  //
}

/**
 * 柱状图标签扩展
 */
export function install(registers: EChartsExtensionInstallRegisters) {
  // * ecModel.setOption() 时
  registers.registerPreprocessor(option => {
    const barSeries = (Array.isArray(option.series) ? option.series : [option.series]).filter(
      item => item.type === 'bar'
    );
    if (barSeries.length === 0) {
      return;
    }

    // @ts-ignore
    parseBarLabelDvPosition(barSeries);
  });
}
